const apiPaths = {
  token: "/admin-token/",
  self: "/users/self/",
  users: "/users",
  drivers: "/drivers",
  stations: "/dock-stations",
  campuses: "/campuses",
  vehicles: "/vehicles",
  vehiclesData: "/vehicles-data",
  vehicleTypes: "/vehicle-types",
  vehicleRoutes: "/vehicle-routes",
  rides: "/rides",
  transactions: "/transactions",
  stats: "/dashboard",
  constants: "/constants",
  subscriptionPlans: "/subscriptions",
  campusSubscriptionPlans: "/campus-subscriptions",
  userPlans: "/user-plans",
  siteSettings: "/site-settings",
};

export default apiPaths;
